import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Calendar,
  DatePicker,
  Button,
  Typography,
  Spin,
  Space,
  ConfigProvider,
} from "antd";
import enGB from "antd/locale/en_GB";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import AttendanceModal from "./component/addModal";
import LeaveModal from "./component/LeaveModal";
import LeaveDetailModal from "./component/LeaveDetailModal";
import AccountPickerModal from "./component/AccountPickerModal";
import http from "@/utils/http";
import api from "@/utils/api";
import "./component/index.css";
import commonFn from "@/utils/commonFn";
const { Title } = Typography;
export default function MangerTimeSheetIndex() {
  dayjs.locale("en-gb");
  const addModalRef = useRef(null);
  const leaveModalRef = useRef(null);
  const [month, setMonth] = useState(dayjs());
  const [loading, setLoading] = useState(false);
  const [calendarData, setCalendarData] = useState({});
  const [leaveDetailVisible, setLeaveDetailVisible] = useState(false);
  const [leaveDetail, setLeaveDetail] = useState(null);
  const accountModalRef = useRef(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [checkRange, setCheckRange] = useState({
    startTime: null,
    endTime: null,
  });
  const handleDateChange = (value) => {
    if (!value) return;
    setMonth(value);
  };
  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const fetchCheckManagerTime = async () => {
    try {
      const res = await http.get(api.getCheckManagerTime);
      setCheckRange({
        startTime: res.data?.startTime || null,
        endTime: res.data?.endTime || null,
      });
    } catch (e) {
      setCheckRange({ startTime: null, endTime: null });
    }
  };

  useEffect(() => {
    fetchCheckManagerTime();
  }, []);
  const getLeaveSummary = (dayData) => {
    const result = [];

    if (dayData.annualTotalHours > 0 || dayData.annualTotalMinutes > 0) {
      const hours = dayData.annualTotalHours || 0;
      const minutes = dayData.annualTotalMinutes || 0;
      result.push({
        type: "annual",
        label: "Annual Leave",
        hours,
        minutes,
        text: minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`,
      });
    }

    if (dayData.sickTotalHours > 0 || dayData.sickTotalMinutes > 0) {
      const hours = dayData.sickTotalHours || 0;
      const minutes = dayData.sickTotalMinutes || 0;
      result.push({
        type: "sick",
        label: "Sick Leave",
        hours,
        minutes,
        text: minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`,
      });
    }

    return result;
  };
  const disabledDate = (current) => {
    if (!current) return false;

    // 范围还没加载回来之前，先全部禁用，避免用户点到不该点的日期
    if (!checkRange.startTime || !checkRange.endTime) return true;

    const start = dayjs(checkRange.startTime).startOf("day");
    const end = dayjs(checkRange.endTime).endOf("day");

    const isBeforeStart = current.isBefore(start, "day");
    const isAfterEnd = current.isAfter(end, "day");

    return isBeforeStart || isAfterEnd;
  };
  const handleSubmit = async (targetMonth) => {
    const dateToUse =
      targetMonth && dayjs.isDayjs(targetMonth) ? targetMonth : month;
    const currentMonth = dayjs.isDayjs(dateToUse) ? dateToUse : dayjs();

    setLoading(true);
    try {
      const res = await http.get(api.getMonthlyData, {
        params: {
          month: currentMonth.format("YYYY-MM"),
          ...(selectedAccount?.id ? { accountId: selectedAccount.id } : {}),
        },
      });

      const map = {};
      (res.data || []).forEach((item) => {
        const [y, m, d] = item.date;
        const key = dayjs(`${y}-${m}-${d}`).format("YYYY-MM-DD");
        map[key] = item;
      });

      setCalendarData(map);
    } finally {
      setLoading(false);
    }
  };
  // 选中的回调
  const handleAccountConfirm = (record) => {
    if (!record) {
      setSelectedAccount(null); // 选了 All，清空筛选
      return;
    }
    setSelectedAccount({ id: record.id, employeesName: record.employeesName });
  };
  useEffect(() => {
    if (!month) return;
    handleSubmit(month);
  }, [month, selectedAccount]);
  const cellRender = (date) => {
    const key = date.format("YYYY-MM-DD");
    const dayData = calendarData[key];

    const hasWorkData =
      dayData &&
      (dayData.totalHours > 0 ||
        dayData.totalMinutes > 0 ||
        dayData.remark ||
        dayData.verified);

    const hasLeave =
      dayData &&
      (dayData.annualTotalHours > 0 ||
        dayData.annualTotalMinutes > 0 ||
        dayData.sickTotalHours > 0 ||
        dayData.sickTotalMinutes > 0);

    // 没有任何数据就不显示
    if (!hasWorkData && !hasLeave) {
      return (
        <div style={{ position: "relative", height: "100%", padding: 12 }}>
          <div className="dateLabel">{date.format("MM/DD/YYYY")}</div>
        </div>
      );
    }

    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          padding: 12,
        }}
      >
        <div className="dateLabel">{date.format("MM/DD/YYYY")}</div>

        <div className="TotalDate">
          {/* 工作记录部分 */}
          {hasWorkData && (
            <>
              <div className="time">
                {dayData.totalHours}h {dayData.totalMinutes}m
              </div>
            </>
          )}

          {/* 请假信息部分 */}
          {hasLeave && (
            <div
              className="leaveTag"
              onClick={(e) => {
                e.stopPropagation();
                if (hasLeave) {
                  openLeaveDetail(dayData);
                }
              }}
              style={{ cursor: hasLeave ? "pointer" : "default" }}
            >
              {getLeaveSummary(dayData).map((item, index) => (
                <div
                  key={index}
                  className={`leave-item ${item.type === "annual" ? "annual-leave" : "sick-leave"}`}
                >
                  <span>{item.label}</span>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const openLeaveDetail = (dayData) => {
    setLeaveDetail(dayData);
    setLeaveDetailVisible(true);
  };
  const handleCalendarSelect = (date) => {
    if (!date) return;
    const key = date.format("YYYY-MM-DD");
    const dayData = calendarData[key] || null;
    addModalRef.current?.open({
      date,
      dayData,
      accountId: selectedAccount?.id,
      employeesName: selectedAccount?.employeesName,
    });
  };

  const handleLeaveSubmit = (type) => {
    leaveModalRef.current?.openModalFn(type);
  };

  useEffect(() => {
    if (!month) return;
    handleSubmit(month);
  }, [month]);

  return (
    <div className="manger-timesheet-page">
      <div className="calendar-header">
        <Title level={4}>Monthly Calendar</Title>
        <Space>
          {(commonFn.btnAuthorityFlag("SelectEmployee") && (
            <Space size="large">
              <Button
                className="btnNew"
                onClick={() =>
                  accountModalRef.current?.open(selectedAccount?.id)
                }
              >
                {selectedAccount
                  ? selectedAccount.employeesName
                  : "Select Employee"}
              </Button>
            </Space>
          )) ||
            null}
          {(!selectedAccount && commonFn.btnAuthorityFlag("AnnualLeave") && (
            <Space size="large">
              <Button
                className="btnNew"
                onClick={() => handleLeaveSubmit("annualLeave")}
              >
                Annual Leave
              </Button>
            </Space>
          )) ||
            null}
          {(!selectedAccount && commonFn.btnAuthorityFlag("SickLeave") && (
            <Space size="large">
              <Button
                className="btnNew"
                onClick={() => handleLeaveSubmit("sickLeave")}
              >
                Sick Leave
              </Button>
            </Space>
          )) ||
            null}
          <DatePicker
            picker="month"
            format="YYYY-MM"
            value={month}
            onChange={handleDateChange}
          />
          <Button type="primary" onClick={handleSubmit} loading={loading}>
            Submit
          </Button>
        </Space>
      </div>

      <Spin spinning={loading} className="calendar-spin">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            textAlign: "center",
            marginBottom: 8,
            fontWeight: 650,
            color: "#17354f",
          }}
        >
          {weekDays.map((day) => (
            <div key={day}>{day}</div>
          ))}
        </div>
        <div className="attendance-calendar-page">
          <ConfigProvider locale={enGB}>
            <Calendar
              value={month}
              cellRender={cellRender}
              headerRender={() => null}
              fullscreen
              onSelect={handleCalendarSelect}
              disabledDate={disabledDate}
            />
          </ConfigProvider>
        </div>
      </Spin>

      <AttendanceModal ref={addModalRef} onSuccess={handleSubmit} />
      <LeaveModal
        ref={leaveModalRef}
        submitInitFn={handleSubmit}
        currentMonth={month}
      />
      <LeaveDetailModal
        open={leaveDetailVisible}
        data={leaveDetail}
        onCancel={() => {
          setLeaveDetailVisible(false);
          setLeaveDetail(null);
        }}
      />
      <AccountPickerModal
        ref={accountModalRef}
        onConfirm={handleAccountConfirm}
      />
    </div>
  );
}
